import React from 'react';
import { HOMEPAGE_FAQS } from '../../seo/businessConfig';

/**
 * HomepageFAQ — visible FAQ block that renders the SAME text used to
 * build the FAQPage JSON-LD in schemas.js. Reading from the same source
 * (HOMEPAGE_FAQS) guarantees the visible copy and the structured data
 * never diverge — a hard requirement for Google's Rich Results validator
 * and for AI answer engines that cross-check the two.
 *
 * All questions and answers are rendered as raw text inside <h3> and
 * <p> elements — no accordions, no client-side reveal patterns — so
 * crawlers that don't execute JavaScript (GPTBot, ClaudeBot, PerplexityBot)
 * see the full copy in the prerendered static HTML.
 */
export default function HomepageFAQ() {
  return (
    <section
      id="faq"
      aria-labelledby="faq-heading"
      className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16"
      data-testid="homepage-faq"
    >
      <h2
        id="faq-heading"
        className="text-2xl md:text-3xl font-bold mb-6 md:mb-8"
      >
        Frequently Asked Questions
      </h2>
      <div className="space-y-6">
        {HOMEPAGE_FAQS.map(({ q, a }) => (
          <div key={q} className="border-b border-neutral-200 pb-6 last:border-b-0">
            <h3 className="text-lg md:text-xl font-semibold mb-2 text-neutral-900">
              {q}
            </h3>
            <p className="text-neutral-700 leading-relaxed">{a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
